<template>
  <div id="app" :class="{ gray: $store.getters.gray }" :data-theme="$store.getters.dataTheme">
    <!--  :class="{ gray: $store.getters.gray }"-->

    <transition
      v-if="$route.meta.type === 'client'"
      enter-active-class="animated fadeIn"
      key="router"
    >
      <!-- :class="editForm.styleType==3?'gradClasstwo':'gradClassone' "    $store.getters.setgradId==3?-->
      <!-- 'background-size':leftbgCAvie='national'?'cover':'' -->
      <div :class="[{'blueBgCol':!haveFj},{'blueBgCol2':haveFj}]">
        <vClientHeader v-if="isShowHeader" :paths="paths" ref="headerChild"></vClientHeader>
        <transition enter-active-class="animated fadeIn">
          <router-view v-if="isRouterAlive"></router-view>
        </transition>

        <!-- <el-dialog :visible.sync="loginVisible" width="30%" :before-close="handleClose">
          <login @closeAlert="handleClose"></login>
        </el-dialog>-->
      </div>
    </transition>

    <transition
      v-else-if="$route.meta.type === 'manage'"
      enter-active-class="animated fadeIn"
      key="manage"
    >
      <router-view />
    </transition>

    <transition v-else name="fade" mode="out-in">
      <div class="content-az"
        :style="{'background-image':paths=='/search'?'url('+leftBg+')':'','background-repeat':'no-repeat','background-size':leftbgCAvie='national'?'cover':''}"
      >
        <router-view></router-view>
      </div>
    </transition>
    <linecom v-if="flgfooter"></linecom>
    <vClientFooter v-if="flgfooter"></vClientFooter>



  <span v-if="json !=''">
    <piaoC2 v-if=" showView && nohome && json.isroll " :json="json" @closeView="closeView"></piaoC2>
  </span>
    

    <span v-if="json2 !=''">
    <piaoC2
      v-if=" showView2 && colocList.length>=2 && nohome && json2.isroll "
      :json="json2 "
      @closeView="closeView2"
    ></piaoC2>
    </span>



    <span v-if="json3 !=''">
    <piaoC2
      style="margin-top: 100px;"
      v-if=" showView3 && colocList.length>=3 && nohome && json3.isroll "
      :json="json3"
      @closeView="closeView3"
    ></piaoC2>
       </span>

    <span v-if="json4 !=''">
      <piaoC2
        v-if=" showView4 && colocList.length>=4 && nohome && json4.isroll "
        :json="json4"
        @closeView="closeView4"
      ></piaoC2>
    </span>



    <el-dialog
      width="800px"
      :visible.sync="prviewPaperVisible"
      :show-close="false"
 
      v-if="prviewPaperVisible"
       :close-on-click-modal="false"
    >
    <div>
      <div style="padding:0 0 15px 0;font-size:36px;font-weight: bold; text-align: center;">网站说明</div>
      <div class="vicalss">
        目前网站因为服务器故障导致暂时无法登录页面进行考试，3月28日至3月31日进行的保密知识正式考试将自动往后顺延；具体考试时间届时在网站首页另行通知！
      </div>
    </div>
    </el-dialog>
  </div>
</template>
<script>
// import vClientHeader from '@/views/header/index';
import vClientHeader from '@/views/header_copy/index';
import vSmallHeader from '@/views/smallHeader/index';
import vClientFooter from '@/views/footer/index';
import Login from '@/views/login/Login';
import { getInfo } from '@/utils/auth';
import linecom from '@/components/linecom/index';
import { CmsWebSetGet } from '@/api/clientshome';
import * as clientshomeApi from '@/api/clientshome/index';
import piaoC2 from '@/components/piaoc/index2';

export default {
  components: {
    vClientHeader,
    linecom,
    vClientFooter,
    Login,
    vSmallHeader,
    piaoC2,
  },
  name: 'home',
  props: {
    msg: String,
  },
  data() {
    return {
      prviewPaperVisible:false,
      ip: '',
      isShowHeader: false,
      flgfooter: false,
      isRouterAlive: true,
      loginVisible: false,
      leftBg: require('/public/img/icons/bgchome.jpg'),
      leftBg01: require('/public/img/icons/bgchome.jpg'),
      leftBg02: require('/public/img/icons/bgchome03.jpg'),
      editForm: {
        styleType: '',
        systemName: '',
        twoWebsite: [],
        webModule: [],
        bottomLink: '',
        paths: '',
      },
      paths: '/home',
      colocList: [],
      json2: '',
      json: '',
      json3: '',
      json4: '',
      nohome: true,
      showView: true,
      showView2: true,
      showView3: true,
      showView4: true,
      leftbgCAvie: '',
      haveFj: false,
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.paths = val.path;
        if (this.paths !== '/home') {
          this.nohome = false;
          sessionStorage.setItem('nohome', false);
        } else {
          this.nohome = true

          const flag = sessionStorage.getItem('nohome');
          this.getcolocList()
          if (flag == 'false') {
            // location.reload();
            sessionStorage.setItem('nohome', true);
          }
        }
      },
    },
  },
  created() {
    this.CmsWebSetGet1();
  },
  updated(){
    if(this.$route.path === '/home' && this.$route.query.isout === 'true'){
      this.toOut();
    }
  },
  beforeDestroy() {
    this.showView = false;
  },
  methods:{
    //直接退出登录
    toOut(){
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/home');
        window.location.reload();
      });
    },
    closeView(val) {
      this.showView = false;
    },
    closeView2(val) {
      // console.log('2');
      this.showView2 = false;
    },
    closeView3(val) {
      this.showView3 = false;
    },
    closeView4(val) {
      this.showView4 = false;
    },
    getcolocList() {
      clientshomeApi.getFloatPage().then((res) => {
        this.colocList = res.result;
        // console.log(res.result)
        setTimeout(() => {
          this.flgfooter = true;
        }, 1500);
        if(this.colocList.length>0){
          this.colocList.forEach((item, index) => {
            item.colserimg = require('@/assets/index/colosemr.png');
            item.left = item.zx;
            item.top = item.zy;
          });

          this.json = this.colocList[0];
          if (this.colocList.length >= 2) {
            this.json2 = this.colocList[1];
          }
          if (this.colocList.length >= 3) {
            this.json3 = this.colocList[2];
          }
          if (this.colocList.length >= 4) {
            this.json4 = this.colocList[3];
          }
        }
      }).catch(err=>{
        console.log(err);
        setTimeout(() => {
          this.flgfooter = true;
        }, 1500);
      })
    },
    CmsWebSetGet1() {
      CmsWebSetGet().then((res) => {
        this.editForm = res.result;
        let a = res.result;
        a.systemName = a.systemName;
        if(a.systemName && a.systemName.includes('辅警')){
          this.haveFj = true;
        }else{
          this.haveFj = false;
        }
        
        // this.editForm.twoWebsite = a.twoWebsite.split(',');
        this.editForm.webModule = a.webModule ? a.webModule.split(',') : '';
        localStorage.setItem('bottomLink', a.bottomLink);
        localStorage.setItem('biaoti', a.systemName);
        localStorage.setItem('examBgColor',a.color);
        localStorage.setItem('englishBiaoTi', a.systemName2);
        document.title = a.systemName;
        localStorage.setItem('twoWebsite', a.twoWebsite);

        this.isShowHeader = true;
        localStorage.setItem('managerUrl', a.managerUrl);
        // console.log(a);
        if (a.styleType == 1) {
          this.$store.commit('setGrayNum', 1);
          this.$store.commit('setGray', false);
          this.$store.commit('setDataTheme', 'default');
          this.leftBg = this.leftBg01;
          this.leftbgCAvie = '';
        } else if (a.styleType == 2) {
          this.$store.commit('setGrayNum', 2);
          this.$store.commit('setGray', false);
          this.$store.commit('setDataTheme', 'default');
        } else if (a.styleType == 3) {
          this.$store.commit('setGrayNum', 3);
          this.$store.commit('setGray', false);
          this.$store.commit('setDataTheme', 'national');
          this.leftBg = this.leftBg02;
          this.leftbgCAvie = 'national';
        } else if (a.styleType == 4) {
          this.$store.commit('setGrayNum', 4);
          this.$store.commit('setGray', true);
          this.$store.commit('setDataTheme', 'default');
          this.leftBg = this.leftBg01;
          this.leftbgCAvie = '';
        }

        // console.log(this.editForm.webModule);
        if (this.editForm.webModule.indexOf('通知公告') !== -1) {
          this.$store.commit('newsboard', true);
        } else {
          this.$store.commit('newsboard', false);
        }

        if (this.editForm.webModule.indexOf('训练专栏') !== -1) {
          this.$store.commit('drillcolumn', true);
        } else {
          this.$store.commit('drillcolumn', false);
        }

        if (this.editForm.webModule.indexOf('微警校') !== -1) {
          this.$store.commit('training', true);
        } else {
          this.$store.commit('training', false);
        }

        if (this.editForm.webModule.indexOf('考试资讯') !== -1) {
          this.$store.commit('testcenter', true);
        } else {
          this.$store.commit('testcenter', false);
        }

        if (this.editForm.webModule.indexOf('优秀教官') !== -1) {
          this.$store.commit('drillmaster', true);
        } else {
          this.$store.commit('drillmaster', false);
        }

        if (this.editForm.webModule.indexOf('排行榜') !== -1) {
          this.$store.commit('rankinglist', true);
        } else {
          this.$store.commit('rankinglist', false);
        }
      });
    },
  },
};
</script>
<style lang="scss">
@font-face {
	font-family: 'Led2';  /* 自定义字体名称 */
	src: url('/font/DigifaceWide.TTF') format('truetype');  /* 文件路径和格式 */
}

#app {
  font-family: '思源黑体', '微软雅黑', sans-serif;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  // @include themeify {
  //   background: themed('color-background-base');
  // }
}
#app.gray {
  filter: grayscale(100%);
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #a1a3a994;
  border-radius: 3px;
}
.gradClassone {
  background-size: contain;
}
.gradClasstwo {
  background-size: 100% 100%;
}
font[size='1'] {
  font-size: 20px;
}
font[size='2'] {
  font-size: 22px;
 
}

.vicalss{
  font-size: 30px;
  line-height: 45px;
  text-indent:2em;
}

.blueBgCol{
  background-image: url('../public/img/bgImg/bg04.png'),url('../public/img/bgImg/bg03.png'),url('../public/img/bgImg/bg02.png'),url('../public/img/bgImg/bg01.png');
  background-repeat: no-repeat,no-repeat,no-repeat,no-repeat;
  background-position: 1222px -463px,-73px 220px, -18px 57px, 0px 0px;
}

.blueBgCol2{
  background-image: url('../public/img/bgImg/bg04.png'),url('../public/img/bgImg/bg03.png'),url('../public/img/bgImg/bg02.png'),url('../public/img/bgImg/bg05.png');
  background-repeat: no-repeat,no-repeat,no-repeat,no-repeat;
  background-position: 1222px -463px,-73px 220px, -18px 57px, 0px 0px;
}

</style>
<style scoped>
/deep/ .el-dialog__header {
  padding: 0;
}
html,
body,
#app {
  height: 100%;
  
}

</style>
